import { Component, Prop, Vue } from 'vue-property-decorator';
import {IdentityCardModalOpener} from '@/public/identity-card/identity-card-modal-opener';
import {IdentityCard} from '@/public/identity-card/identity-card-component/identity-card-component';


@Component({
})
export default class IdentityCardMenuItemComponent extends Vue {

    @Prop() public identity!: IdentityCard;
    @Prop() public translations!: { [key: string]: string; };
    @Prop({ default: 'sv-SE' }) public language!: string;

    constructor() {
        super();
    }

    public async open($event: MouseEvent): Promise<void> {

        $event.preventDefault();

        const containerElement = this.$refs.container as Element;

        await IdentityCardModalOpener.openAsync(containerElement, this.identity, this.translations, this.language);
    }
}
